module.exports = __webpack_public_path__ + "static/media/banner-aug-23-desktop.5f374c44.png";